module.exports = __webpack_public_path__ + "static/media/ch.bb32d428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/ch.svg
// module id = 1437
// module chunks = 0